import React from 'react';
import { observer } from 'mobx-react-lite';
import { convertAmount, tableBetHistoryStore, useTranslation } from '@pascal/pascal-core';

import '../SelectedHistory.scss';
import { TranslationKeys } from '../../../enums/translationKeys';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { data: thirdStepData } = thirdStep;
  const t = useTranslation();

  return (
    <div className='crazy-worm-history-el'>
      <div className='crazy-worm-history-head'>
        <div className='crazy-worm-current-result'>
          <span>x{thirdStepData.roundData}</span>
          <h5 className='crazy-worm-current-label'>{t(TranslationKeys.GameResult)}</h5>
        </div>
        <div className={`crazy-worm-history-multi ${thirdStepData.winAmount ? 'win' : 'lose'}`}>
          <span>x{thirdStepData.odd}</span>
          <h5 className='crazy-worm-multi-label'>{t(TranslationKeys.YourMultiplier)}</h5>
        </div>
      </div>
      <div className='tb-game-history-bet-info-wrp'>
        <div className='tb-game-history-bet-info-header'>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t(TranslationKeys.BetAmount)}</p>
          </div>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t(TranslationKeys.Odd)}</p>
          </div>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t(TranslationKeys.Win)}</p>
          </div>
        </div>
        <div className='tb-game-history-bet-info-main'>
          <div className='tb-game-history-bet-info-main-row'>
            <div className='tb-his-bet-info-main-row-ins-cl bet'>
              <p className='tb-his-bet-info-main-txt'>{`${
                thirdStepData.freeBetId ? `${t(TranslationKeys.FreeBet)}:` : ''
              } ${convertAmount(thirdStepData.amount)}`}</p>
            </div>
            <div className='tb-his-bet-info-main-row-ins-cl'>
              <p className='tb-his-bet-info-main-txt'>{thirdStepData.odd}</p>
            </div>
            <div className='tb-his-bet-info-main-row-ins-cl bet'>
              <strong className='tb-his-bet-info-main-txt win'>
                {convertAmount(thirdStepData.winAmount)}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
